import React from 'react';
import './PageRibbon.css';

interface PageRibbonProps {
  title: string;
  icon: React.ReactNode;
  subtitle?: string;
  actions?: React.ReactNode;
}

export const PageRibbon: React.FC<PageRibbonProps> = ({ title, icon, subtitle, actions }) => {
  return (
    <div className="page-head">
      <div className="page-head__main">
        {icon ? <span className="page-head__icon" aria-hidden>{icon}</span> : null}
        <div>
          <h1>{title}</h1>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
      </div>
      {actions ? <div className="page-head__actions">{actions}</div> : null}
    </div>
  );
};

export default PageRibbon;
